<template>
  <div class="talentList managementList" :style="{'margin-top': listOptions.total_count == 0 ? '20px' : '0' }">
    <template v-if="!isLoading && ( listOptions.total_count>0 && getStoreResumeList.list.length)">

      <div class='list bg_fff cursor_p pr transition_2' data-growing-title='简历卡片' data-growing-container  v-for="(item, index) in getStoreResumeList.list" :key="index + '&cardList'" @click="getDetail(item,index)">
        <div class="newtop-content bg_fa f_14" :class="{'delivery-card-top': routePageName==='talentDelivery'}">
          <div class="choose-delivery" v-if="routePageName==='talentDelivery'" @click.stop="check(index)">
            <span class="iconfont iconxuanzhong" v-if="downloadParamList[index] && downloadParamList[index].checked" />
            <span class="iconfont iconweixuanzhong" v-else />
          </div>
          <!-- 顶部左侧 -->
          <div>
            <div class="flex">
              <div :class="['headImg pb', !userInfoState ? 'informationBlur' : '']" >
                <div class="pa img" :style="{backgroundImage:'url('+ (item.resume.info.profile.avatar_url || headImgList.round[item.resume.user_id%5]) +')',backgroundSize:'cover'}">
                  <div :class="(item.viewed !== undefined && !item.viewed && routePageName==='talentDelivery' ) ? 'newtips' : '' "></div>
                </div>
                <div :style="{left:lastActiveAt(item.resume.info.basic_info.updated_at) == '3日内活跃' ?  '-11px' : '-7px'}" class="online-text" v-if="lastActiveAt(item.resume.info.basic_info.updated_at)"><div  class="circle"></div>{{lastActiveAt(item.resume.info.basic_info.updated_at)}}</div>
                <!-- <div class="gender pa iconfont" :class="[item.resume.info.profile.gender==='男'?'iconnan':'',item.resume.info.profile.gender==='女'?'iconnv':'',]"></div> -->
              </div>
              <div class="user-info" >
                <div class="flex">
                  <!-- 用户名 -->
                  <div class="userName">
                    <div class="name color_40 f_18 font_w_b pr fl" :class="[ !userInfoState ? 'informationBlur4' : '', (item.viewed !== undefined && !item.viewed && routePageName==='talentDelivery' ) ? 'tips' : '']">{{item.resume.info.profile.username}}</div>
                    <!-- <div class="onlineAt f_14 color_9c fl" v-if="lastActiveAt(item.resume.info.basic_info.updated_at)" >{{lastActiveAt(item.resume.info.basic_info.updated_at)}}</div> -->
                  </div>
                  <div class="leftItem color_40 f_14 beforeText ellipsis" style="margin-bottom:10px">
                    <!-- 年纪 -->
                    <span class="display_ib" v-if="getAge(item.resume.info.profile.birthday)" >{{getAge(item.resume.info.profile.birthday)}}</span>
                    <!-- 性别 -->
                    <span class="display_ib" v-if="item.resume.info.profile.gender">{{item.resume.info.profile.gender}}</span>
                    <!-- 工作年限/毕业时间 -->
                    <span class="display_ib" v-if="workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})" >{{workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})}}</span>
                    <!-- 最高学历 -->
                    <span class="display_ib" v-if="getDegreeName(item.resume.info, item.recent_edu_index)" >{{getDegreeName(item.resume.info, item.recent_edu_index)}}</span>
                    <span class="remark" v-if="item.remark">备注：{{item.remark}}</span>
                  </div>
                </div>
                <div class="text beforeText fl color_40" v-if="topContentVisible">
                  期望：
                  <span class="display_ib" v-if="(item.resume.info.basic_info.predicted_location && item.resume.info.basic_info.predicted_location.length) || (item.resume.info.basic_info.expected_location && item.resume.info.basic_info.expected_location.length)">{{item.resume.info.basic_info.expected_location.length ? item.resume.info.basic_info.expected_location.join('/') : item.resume.info.basic_info.predicted_location.join('/')}}</span>
                  <span class="display_ib" v-if="item.resume.info.profile.exp_job">{{item.resume.info.profile.exp_job}}</span>
                  <span class="display_ib" v-else-if="item.resume.info.basic_info.exp_job">{{item.resume.info.basic_info.exp_job}}</span>
                  <span class="display_ib">{{expected_salary(item.resume.info.profile.expected_salary) || expected_salary(item.resume.info.basic_info.expected_salary) || '面议'}}</span>
                </div>
                <!-- <div class="permissionState f_14 color_9c fr" v-if="!!item.hr_permission_state">{{item.hr_permission_state | hrPermissionState}}</div> -->
              </div>
            </div>
            <div class="highligt-body">
              <div v-for="(sitem,index) in item.heighlightTags" :key="index "  class="highlight">{{sitem}}</div>
              <div v-for="(sitem,index) in item.skillTags" :key="index + 'b' "  class="skill-tags highlight">{{sitem}}</div>
            </div>
          </div>
          <div class="buttons_right">
          <el-tooltip v-if="
            item.resume.contact_directly &&
            !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') &&
            !item.delivery_status &&
            !(routePageName==='talentDelivery' || routePageName==='talentRefuseDelivery')
            "
            class="item" effect="dark" content="该人才可直接获取电话" placement="top-end" >
              <div :class="[
                (item.resume.contact_directly &&
                !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') &&
                !item.delivery_status &&
                !(routePageName==='talentDelivery' || routePageName==='talentRefuseDelivery')
                )? 'buttons' : 'buttons bg_60 color_9c disabled']" @click.stop="getPhone({item,index})">
                <span class="iconfont iconGroup311" ></span>
                <p>查看电话</p>
              </div>
            </el-tooltip>
          <!-- 顶部右侧 -->
          <div :class="routePageName !== 'talentCollection' && routePageName !== 'talentRefuseDelivery' ? 'standard-btn-content w200' :'standard-btn-content'" >
            <!-- {{routePageName}} -->
            <div class="standard-btn-left" v-if="routePageName=='talentMessage' || routePageName=='talentCollection' " @click.stop="resumeApply(item.hr_permission_state, JSON.parse(JSON.stringify(item)), index )">
              <template v-if="routePageName == 'talentCollection'">{{!item.hr_permission_state && !item.delivery_status ? '联系Ta' : '继续沟通'}}</template>
              <template v-else>{{!item.hr_permission_state ? '联系Ta' : '继续沟通'}}</template>
            </div>
            <div class="standard-btn-left" v-if="routePageName==='talentDelivery'" @click.stop="deliveryToChatPage(item, index)">
              继续沟通
            </div>
            <div class="standard-btn-left" @click.stop="unsuitable(!!item.unsuited,item,index)" v-if="routePageName === 'talentRefuseDelivery'">
              {{!item.unsuited ? '不合适' : '取消不合适'}}
            </div>
            <div class="standard-btn-right" @click.stop="item.is_favorite ? changeCancelState(item, index) : resumeCollect(item,index)">
              <span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive star color_ffc':'iconfavorites star color_40']"></span>
              {{item.is_favorite?'移除储备':'储备'}}
            </div>
            <el-tooltip content="不合适" placement="top">
              <div class="dislike" @click.stop="unsuitable(!!item.unsuited,item,index)" v-if="routePageName !== 'talentCollection' && routePageName !== 'talentRefuseDelivery'">
                <i class="iconfont iconrencaituijian-copy"></i>
              </div>
            </el-tooltip>


          </div>
          </div>
        </div>
        <div class="userInfo flex new-content">
          <!-- 中间内容区域 -->
          <div class="centerContent clearfix flex1" :class="[routePageName==='talentDelivery' || routePageName==='talentRefuseDelivery' ? 'hasHighlightLength' : '']">

            <!-- 用户基本信息及 学校信息 -->
            <div class="leftCont fl" style="display: none">
              <!-- 用户名 -->
              <div class="userName clearfix">
                <div class="name color_40 f_18 font_w_b pr fl" :class="[ !userInfoState ? 'informationBlur4' : '', (item.viewed !== undefined && !item.viewed && routePageName==='talentDelivery' ) ? 'tips' : '']">{{item.resume.info.profile.username}}</div>
                <div class="onlineAt f_14 color_9c fl" v-if="lastActiveAt(item.resume.info.basic_info.updated_at)" >{{lastActiveAt(item.resume.info.basic_info.updated_at)}}</div>
              </div>
              <div class="leftItem color_40 f_14 beforeText" style="margin-bottom:18px">
                <!-- 年纪 -->
                <span class="display_ib" v-if="getAge(item.resume.info.profile.birthday)" >{{getAge(item.resume.info.profile.birthday)}}</span>
                <!-- 工作年限/毕业时间 -->
                <span class="display_ib" v-if="workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})" >{{workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})}}</span>
                <!-- 最高学历 -->
                <span class="display_ib" v-if="getDegreeName(item.resume.info, item.recent_edu_index)" >{{getDegreeName(item.resume.info, item.recent_edu_index)}}</span>
              </div>
              <template v-for="(sitem, sindex) in item.resume.info.education_experiences">
                <div class="leftItem color_40 f_14 clearfix" :key="sindex + '&cardListItem'" v-if="sindex<2">
                  <div class="beforeText ellipsis fl leftItemTags">
                    <!-- 学校名称 -->
                    <span v-if="sitem.cust_uni_name || sitem.school.cn" >{{sitem.cust_uni_name || sitem.school.cn}}</span>
                    <!-- 专业 -->
                    <span v-if="sitem.cust_major_name || sitem.major_name.cn" >{{sitem.cust_major_name || sitem.major_name.cn}}</span>
                    <!-- 学历 -->
                    <span v-if="sitem.cust_degree || sitem.degree_name.cn" >{{sitem.cust_degree || sitem.degree_name.cn}}</span>
                    <span v-if="sitem.edu_type==='非全日制'" >非全日制</span>
                  </div>
                  <div class="schoolTag f_12 color_blue fl" v-if="schoolTag(sitem.school.tag_names)">{{schoolTag(sitem.school.tag_names)}}</div>
                </div>
              </template>

            </div>

            <div class="fl flex content">
              <!-- 工作经历 -->
              <div class="work-list pr flex1" :style="{maxWidth:routePageName==='talentDelivery'?'calc(100% - 200px)':'calc(100% - 105px)'}">
                <!-- 左侧分割线 -->
                <div class="divid pa text_center color_fff">
                  <div class="start iconfont iconGroup32 pa"></div>
                </div>

                <div class="item" v-if="!(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length + item.resume.info.education_experiences.length)">
                  <div class="name f_14 color_40 beforeText">这位候选人还没有任何经历，快去看看其他候选人吧～</div>
                </div>
                <div class="item" v-else-if="!(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)">
                  <div class="text f_12 color_9c beforeText mr48"> - </div>
                  <div class="name f_14 color_40 beforeText">暂无工作经历</div>
                </div>

                <template>
                   <!-- 有工作经历 -->
                  <template v-if="filterWork(item.resume.info.work_experiences).length">
                    <template v-for="(item,index) in filterWork(item.resume.info.work_experiences, item.keyword_hit)" >
                      <div class="item" :key="'work_experiences_'+String(index)" v-if="index<2">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="item.start_at||item.end_at || item.present">
                            <i v-if="item.start_at">{{splitTime(item.start_at)}}</i>
                            <i v-if="item.end_at || item.present">{{splitTime(item.end_at || item.present)}}</i>
                          </span>
                          <span class="display_ib">就职</span>
                          <span class="display_ib" v-if="getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})">{{getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})}}</span>
                        </div>
                        <div class="name f_14 color_40 beforeText ellipsis">
                          <span class="ellipsis" v-if="item.company_name" v-html="item.company_name"></span>
                          <span class="ellipsis" v-if="item.title" v-html="item.title"></span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 实习经历 -->
                  <template v-if="filterWork(item.resume.info.work_experiences).length<2 && filterWork(item.resume.info.internship_experiences).length">
                    <template v-for="(sitem,sindex) in filterWork(item.resume.info.internship_experiences, item.keyword_hit)" >
                      <div class="item" :key="'internship_experiences_'+String(sindex)" v-if="sindex < (filterWork(item.resume.info.work_experiences).length ? 1 : 2)">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                            <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                            <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                          </span>
                          <span class="display_ib">实习</span>
                          <span class="display_ib" v-if="getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})">{{getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})}}</span>
                        </div>
                        <div class="name f_14 color_40 beforeText ellipsis">
                          <span class="ellipsis" v-if="sitem.company_name" v-html="sitem.company_name"></span>
                          <span class="ellipsis" v-if="sitem.job_title" v-html="sitem.job_title"></span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 项目经历 -->
                  <template v-if="(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)<2 && filterCustomSections(item.resume.info.project_experiences).length">
                    <template v-for="(sitem, sindex) in filterCustomSections(item.resume.info.project_experiences)" >
                      <div class="item" :key="'project_experiences'+sindex" v-if="sindex<1">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                            <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                            <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                          </span>
                          <span class="display_ib">项目</span>
                        </div>
                        <div class="name f_14 color_40 beforeText ellipsis">
                          <span class="ellipsis" v-if="sitem.name">{{sitem.name}}</span>
                          <span class="ellipsis" v-if="sitem.title">{{sitem.title}}</span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 社团经历 -->
                  <template v-if="(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)<2 && !filterCustomSections(item.resume.info.project_experiences).length && filterInfoSections(item.resume.info.orgs).length">
                    <template v-for="(sitem, sindex) in filterInfoSections(item.resume.info.orgs)" >
                      <div class="item" :key="'orgs'+sindex" v-if="sindex<1">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                            <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                            <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                          </span>
                          <span class="display_ib">社团</span>
                        </div>
                        <div class="name f_14 color_40 beforeText">
                          <span class="ellipsis" v-if="sitem.name">{{sitem.name}}</span>
                          <span class="ellipsis" v-if="sitem.title">{{sitem.title}}</span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 教育经历 -->
                  <template v-if="item.resume.info.education_experiences.length > 0" >
                    <template v-for="(sitem,sindex) in item.resume.info.education_experiences" >
                      <div class="item"  v-if="sindex < 2" :key="sindex + 'a'">
                        <div v-if="sindex == 0" class="divid-end text_center color_fff iconfont iconGroup12 pa"></div>
                        <div class="text f_12 color_9c mr48">
                          <span class="display_ib time" v-if="sitem.start_at">{{splitTime(sitem.start_at.split(' ')[0])}}</span> -
                          <span v-if="sitem.end_at">{{splitTime(sitem.end_at.split(' ')[0])}}</span>
                        </div>
                        <div :class="[{splitnone: schoolTag(sitem.school.tag_names)},'name f_14 color_40 beforeText ellipsis']">
                          <span class="ellipsis" v-if="sitem.cust_uni_name || sitem.school.cn">{{sitem.cust_uni_name || sitem.school.cn}}</span>
                          <span class="ellipsis" v-if="sitem.cust_major_name || sitem.major_name.cn">{{sitem.cust_major_name || sitem.major_name.cn}}</span>
                          <span v-if="sitem.cust_degree || sitem.degree_name.cn">{{sitem.cust_degree || sitem.degree_name.cn}}</span>
                          <span v-if="sitem.edu_type==='非全日制'" >非全日制</span>
                          <div class="schoolTag f_12 color_blue fl" v-if="schoolTag(sitem.school.tag_names)">{{schoolTag(sitem.school.tag_names)}}</div>
                        </div>
                      </div>
                    </template>

                  </template>
                </template>
              </div>

              <div class="features pr" :style="{display: 'none', minWidth:routePageName==='talentDelivery'?'200px':'auto'}">
                <!-- item.hr_permission_state==='passed' ? 'es-highlighter' :'color_9c' -->
                <!-- 储备人才 -->
                <template v-if="routePageName==='talentCollection'">
                  <div class="funtionButton f_14 color_blue cursor_p pr" @click.stop="resumeApply(item.hr_permission_state, JSON.parse(JSON.stringify(item)), index )">
                    <span class="iconfont iconGroup311" v-if="item.resume.contact_directly && !item.hr_permission_state && !item.delivery_status"></span>
                    {{!item.hr_permission_state && !item.delivery_status ? '联系Ta' : '继续沟通'}}
                    <div class="tips pa f_14 color_9c text_center bg_fff" v-if="item.resume.contact_directly && !item.hr_permission_state && !item.delivery_status">该人才可直接获取电话</div>
                  </div>
                  <div class="favorite f_14 color_40 cursor_p" @click.stop="item.is_favorite ? changeCancelState(item, index) : resumeCollect(item,index)"><span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive current':'iconfavorites color_9c']"></span>{{item.is_favorite?'移除储备':'储备'}}</div>
                </template>
                <!-- 待处理/不合适 -->
                <!-- <div class="buttons clearfix" v-if="routePageName==='talentDelivery' || routePageName==='talentRefuseDelivery'">
                  <div class="fr funtionButton f_14 color_blue cursor_p" v-if="routePageName!=='talentRefuseDelivery'" @click.stop="deliveryToChatPage(item, index)">继续沟通</div>
                  <div class="fr funtionButton f_14 color_9c cursor_p" @click.stop="unsuitable(!!item.unsuited,item,index)">{{!item.unsuited ? '不合适' : '取消不合适'}}</div>
                </div> -->
                <!-- 邀约记录 -->
                <div class="buttons clearfix" v-if="routePageName==='talentMessage'">
                  <div class="fr funtionButton f_14 color_blue cursor_p" @click.stop="resumeApply(item.hr_permission_state,item, index )">
                    <!-- <span class="iconfont iconGroup311" v-if="(item.visibility==='in_public' || item.visibility==='hr_visible') && !item.hr_permission_state"></span> -->
                    {{!item.hr_permission_state ? '联系Ta' : '继续沟通'}}
                    <div class="tips pa f_14 color_9c text_center bg_fff" v-if="(item.visibility==='in_public' || item.visibility==='hr_visible') && !item.hr_permission_state">该人才可直接获取电话</div>
                  </div>
                </div>

              </div>

            </div>

          </div>
          <div v-if="!!item.hr_permission_state && routePageName == 'talentMessage'" :class="['invited-status','position_b_86',{'resove-status': item.hr_permission_state !== 'rejected' }]">{{ item.hr_permission_state === 'rejected' ? '邀约被拒' : (item.hr_permission_state === 'passed')  ? '已通过' : '待通过' }}</div>
        </div>
        <!-- 新投递 -->
        <div class="message clearfix color_40 f_14 expect-border" v-if="routePageName==='talentDelivery'">
          <div class="fl">投递时间：{{applied_at(item.applied_at)}}</div>
          <div class="fl">投递职位：{{item.job_post}}</div>
          <div class="fr colors"  v-if="item.is_top_delivery">该人才通过精准曝光投递了您的职位</div>
          <!-- <div class="favorite f_14 color_40 cursor_p fr" @click.stop="resumeCollect(item,index)"><span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive current':'iconfavorites color_9c']"></span>{{item.is_favorite?'移除储备':'储备'}}</div> -->

        </div>
        <!-- 不合适 -->
        <div class="message clearfix color_40 f_14 expect-border" v-if="routePageName==='talentRefuseDelivery'">
          <div class="fl">{{item.delivery_status ? '投递' : '邀约'}}时间：{{applied_at(item.applied_at)}}</div>
          <div class="fl">{{item.delivery_status ? '投递' : '邀约'}}职位：{{item.job_post}}</div>
          <div class="fr colors"  v-if="item.is_top_delivery">该人才通过精准曝光投递了您的职位</div>
          <!-- <div class="favorite f_14 color_40 cursor_p fr" @click.stop="resumeCollect(item,index)"><span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive current':'iconfavorites color_9c']"></span>{{item.is_favorite?'移除储备':'储备'}}</div> -->

        </div>
        <!-- 邀约记录 -->
        <div class="message clearfix color_40 f_14 expect-border" v-if="routePageName==='talentMessage'">
          <div class="fl">邀约时间：{{applied_at(item.created_at)}}</div>
          <div class="fl">邀约职位：{{item.job_post}}</div>
          <!-- <div class="favorite f_14 color_40 cursor_p fr" @click.stop="resumeCollect(item,index)"><span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive current':'iconfavorites color_9c']"></span>{{item.is_favorite?'移除储备':'储备'}}</div> -->
        </div>
        <Group :key="index + 'b'" :currentResume="currentResume.resume" @close="()=>{showGroup=!showGroup}" @getList="getList" v-if="currentResume && showGroup && currentIndex == index"  :top="routePageName==='talentMessage' ? '88px' : '73px'" :right="'32px'"></Group>
        <CancelCollection :currentResume="currentResume.resume" :routePageName="routePageName" @close="()=>{showCancelCollection=!showCancelCollection}" @setGroup="setGroup" @cancel="resumeCollect(item,index)" v-if="currentResume && showCancelCollection && currentIndex == index"  :top="routePageName==='talentMessage' ? '88px' : '73px'" :right="'75px'" />
      </div>

      <!-- 付费引导入口 -->
      <div class="entrance-box">

        <div class="entrance-item">
          <div class="entrance-item-left">
            <img src="https://files.wondercv.com/hr-pc/entrance-icons1.png" alt="">
            <div class="entrance-text-box">
              <h6>2022校招解决方案</h6>
              <p>定制专业的校园招聘解决方案，提前锁定心仪人才</p>
            </div>
          </div>
          <a class="entrance-item-right" href="https://mp.weixin.qq.com/s/zfVguYhX2vkdh9nJ_-aq4w" target="_blank">联系我们</a>
        </div>

        <div class="entrance-item">
          <div class="entrance-item-left">
            <img src="https://files.wondercv.com/hr-pc/entrance-icons2.png" alt="">
            <div class="entrance-text-box">
              <h6>精准曝光</h6>
              <p>大幅提高职位曝光，快速获得海量人才投递！</p>
            </div>
          </div>
          <div class="entrance-item-right" @click="toTopJob">立即曝光</div>
        </div>

      </div>

      <el-pagination background layout="prev, pager, next" :total="listOptions.total_count" :page-size="15" :currentPage="Number(listOptions.page)" @current-change='pageChange' class="searchPagination text_center" v-if="listOptions.total_count>15"></el-pagination>
    </template>

    <template v-else-if="!isLoading && (!listOptions.total_count || !getStoreResumeList.list.length)">
      <div class="talent_notfound bg_fff text_center">
        <img src="https://files.wondercv.com/searchResume_pc/talent_notfound.png" alt="">
        <p class="f_16 color_60">
          <span v-if="routePageName === 'talentMessage'">暂无消息</span>
          <span v-else>暂无储备</span>
        </p>
        <div class="button color_blue cursor_p f_14" @click="$router.push({name:'talentSearchIndex'})">去搜简历</div>
      </div>
    </template>

    <!-- 申请简历弹窗 -->
    <resume-apply v-if="showResumeApplyState"/>
    <!-- 无简历提示 -->
    <notfind-resume v-if="notfindResumeState" @setNotfindResumeState="setNotfindResumeState" />
    <!-- 绑定手机号弹窗 -->
    <bind-phone v-if="showBindPhone" @bindPhoneSuccess="bindPhoneSuccess" @closeBindPhone="closeBindPhone" />
    <!-- 购买查看电话次数弹窗 -->
<!--      <job-pay-dialog-->
<!--      v-if="showBuyPhoneState"-->
<!--      payType="bPhone"-->
<!--      :orderPriceText="1050"-->
<!--      type="phone"-->
<!--      title="查看电话"-->
<!--      subtitle="无需等待候选人同意邀约，直接查看联系方式，购买后无使用限制，用完即止"-->
<!--      @paidFunc="paidSuccFunc"-->
<!--      @closeFunc="closeBuyPhone"/>-->
  </div>
</template>

<script>
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';
// 所有接口
import actions from '@/actions/index'

import {checkUserState, get_tUser } from '@/utils/utils';
import { filterInfoSections, filterCustomSections, getAge, applied_at, getDegreeName, schoolTag, getWorkTimeLength } from '@/utils/resumeList';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
// 申请简历
import ResumeApply from '@/components/block/ResumeApply'
// 无简历提示
import NotfindResume from '@/components/notfind-resume/index'
//绑定手机号
import BindPhone from '@/components/bindPhone'
import JobPayDialog from '@/components/block/JobPayDialog'

import Group from '@/components/collection/group.vue'
import CancelCollection from '@/components/collection/CancelCollection.vue'
export default {
  name: 'ImResumeList',
  mixins:[mixinsUtils],
  props:{
    // 控制卡片顶部期望是否显示
    topContentVisible: {
      type: Boolean,
      default: true
    },
    isLoading:{},
    downloadParamList: {
      type: Array,
      default: () => []
    }
    // classType:{
    //   default:1, // 1普通列表，2已通过，3简历收藏/未通过，4待处理
    // },
  },
  data(){
    return {
      // showResumeApplyState:false,
      checkRequestState:{ //接口请求状态
        resumeApply:false,
        downLoad:false,
      },
      pageName: this.$route.name,
      listType: '',
      notfindResumeState: false, //是否显示无在线简历提示
      userJWT:{},
      showBindPhone: false, //是否显示绑定手机号弹窗
      bindData:{}, //账户绑定数据
      resumeOperationState: false, //相关操作，接口请求状态
      showGroup: false,  // 展示分组
      showCancelCollection: false,  // 展示取消收藏的弹窗
      currentResume: '', // 当前点击的简历卡片
      currentIndex: 0, // 当前点击简历卡片的下标
    }
  },
  computed:{
    ...mapState('block',['userInfoState','userinfoTipsState', 'showResumeApplyState','getPhoneNumber','showBuyPhoneState']),
    ...mapState('resumeDetails',['routePageName', 'resumeDetail', 'myPosition', 'listOptions', 'resumeDetailToken']),
    ...mapState('im',[ 'hr_account_token']),
    ...mapState('message',[ 'messageCount'] ),
    ...mapGetters('resumeDetails',[ 'getStoreResumeList'] ),
    showPhone: function(){
      return  this.resumeDetail.resume.contact_directly &&    // 是否可极速联系
      !(this.resumeDetail.hr_permission_state==='rejected' || this.resumeDetail.hr_permission_state==='passed') && // 邀约状态是通过或者拒绝不显示
      !this.resumeDetail.delivery_status &&
      !(this.routePageName==='talentDelivery' || this.routePageName==='talentRefuseDelivery') &&  // 页面判断
      !(this.routePageName==='talentChat' && this.chatInfo.t_id ? false : this.chatInfo.origin===2) &&
      !(this.routePageName==='talentMessage' && !this.messageOther)
    },
  },
  components:{
    ResumeApply,
    NotfindResume,
    BindPhone,
    // JobPayDialog,
    Group,
    CancelCollection
  },
  created() {
    this.userJWT = get_tUser();
    // 获取用户绑定信息
    this.getUsersBind();
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','toggleUserinfoTips','toggleTipsType', 'updateBlockStateFun','updatePhoneNumberStateFun','updatePhoneNumberToken','updatePhoneNumber']),
    ...mapMutations('resumeDetails',['updateResumeDetail', 'updateListOptions', 'updateResumeListObj','updateSearchIndexObj','updateResumeDetailToken','updateDownloadResumeInfo']),
    ...mapMutations('message',[ 'updateMessageCount'] ),
    ...mapMutations('im',[ 'updateChatUserList', 'updateChatAllUserList', 'updateSmallChatOpenId']),
    ...mapActions('resumeDetails',['getMyPosition']),
    ...mapMutations('delivery', ['updateCvCount']),
    // 选中/反选
    check(index) {
      this.$emit('check', index)
    },
    getList() {
      if (this.$route.name === 'talentCollection') {
        this.$emit('getList');
      }
    },
    changeCancelState(item, index) {
      this.showCancelCollection = true
      this.currentResume = item
      this.currentIndex = index
    },
    // 移除储备时选择分组
    setGroup() {
      // this.currentResume = item
      this.showGroup = true
    },
    pageChange(e){
      this.$emit('pageChange',e)
    },

    //进入详情页
    async getDetail(item,index){
      this.updateDownloadResumeInfo(item)
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          this.$router.replace({name:'talentSearchIndex'});
          return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      let token = item.resume.token;

      this.$emit('getDetail',{token, index, item});

      // 修改待处理红点状态
      if(this.routePageName === 'talentDelivery' && !item.viewed){
        //更改红点状态
        item.viewed = true;
        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))
        getStoreResumeList.list[index] = item;
        this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});
        //更改未读红点数量
        this.updateMessageCount({type:'unviewed_job_deliveries_count',count: this.messageCount.unviewed_job_deliveries_count-1})
      }
      this.updateListOptions({
        ...this.listOptions,
        resumeIndex: index
      })
    },
    //收藏/取消收藏
    async resumeCollect(item,index){
      // console.log(item);
      this.currentIndex = index
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          this.$router.replace({name:'talentSearchIndex'});
          return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      //引导用户完善信息弹层
      if(!this.userInfoState){
        //更新是否完善信息(状态库)
        let userInfo = await actions.hr_accounts.getUserinfo();
        this.toggleUserInfoState(userInfo)
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true);
          return false;
        }
      }
      if(this.resumeOperationState){
        return
      }
      this.resumeOperationState = true;

      let token = item.resume.token;
      let is_favorite = item.is_favorite;
      let data = {
        token,
        type: is_favorite ? 'dislike' : 'like'
      }

      // b向c发送通知
      if(!is_favorite && item.resume.cv_account_token){
        actions.im.sendNotifications({
          type: 'collect',
          cv_account_token: item.resume.cv_account_token,
          app_push: true,
          wechat_message: true
        })
      }
      // 储备
      let flag = true
      if(!is_favorite){
        let res = await actions.favorites.favorites_add_group({token, job_id: item.resume.job_id})
        this.resumeOperationState = false;
        if(res.code == 1000) {
          this.$message.success('已储备至默认分组')
          this.currentResume = item
          this.showGroup = true
        } else {
          this.$message.error(res.message)
          flag = false
        }
      } else {
        let ress = await actions.favorites.favorites_chancle_group({token, job_id: item.resume.job_id})
        this.resumeOperationState = false;
        if(ress.code == 1000) {
          this.$message.success('移除成功')
        } else {
          this.$message.error(ress.message)
          flag = false
        }
      }
      if(flag && index >-1) {
        //更改列表收藏状态
        item.is_favorite = item.is_favorite ? false : true;
        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))
        getStoreResumeList.list[index] = item;
        this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});
        //更改收藏红点数量
        let favorite_count = this.messageCount.favorite_count;
        this.updateMessageCount({type:'favorite_count',count: is_favorite ? favorite_count-1 : favorite_count+1})

        //储备列表 && 移除储备
        if(this.routePageName ==='talentCollection' && is_favorite){
          this.$emit('checkUpdateList', index)
        }
      }
      return
      actions.favorites.favorites_status(data).then(res=>{
        this.resumeOperationState = false;

        if(res.code === 1000){
          //更改列表收藏状态
          item.is_favorite = item.is_favorite ? false : true;
          let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))
          getStoreResumeList.list[index] = item;
          this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});

          //更改收藏红点数量
          let favorite_count = this.messageCount.favorite_count;
          this.updateMessageCount({type:'favorite_count',count: is_favorite ? favorite_count-1 : favorite_count+1})

          //储备列表 && 移除储备
          if(this.routePageName ==='talentCollection' && is_favorite){
            this.$emit('checkUpdateList', index)
          }
          this.$message({
            message: is_favorite ? '移除成功' : '已添加至储备人才',
            type: 'success'
          });
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //返回 满足条件的内容【有公司名称】
    checkWork(work_experiences){
      let html = '';
      let workIndex = -1;
      work_experiences && work_experiences.forEach((item,index) => {
        if(item.company_name && workIndex<0){
          workIndex = index;
        }
      });
      if(workIndex>-1){
        html += `<span class="ellipsis display_ib max70">${work_experiences[workIndex].company_name}</span>`
        if(work_experiences[workIndex].title){
          html += `<span class="flex1 ellipsis">${work_experiences[workIndex].title}</span>`
        }
      }
      return html
    },
    //返回 满足条件的内容【有学校名称】
    checkEdu(education_experiences, lang){
      let html = '';
      let eduIndex = -1;
      education_experiences && education_experiences.forEach((item,index) => {
        if((item.cust_uni_name || item.school[lang]) && eduIndex<0){
          eduIndex = index;
        }
      });
      if(eduIndex>-1){
        html += `<span>${education_experiences[eduIndex].cust_uni_name || education_experiences[eduIndex].school[lang]}</span>`
        if(education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]){
          html += `<span>${education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]}</span>`
        }
        if(education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]){
          html += `<span>${education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]}</span>`
        }
      }
      if(html.length){
        html = "<div class='afterText' style='width:100%;'>"+ html
        html+="</div>"
      }
      return html
    },

    //过滤空公司信息
    filterWork(work_experiences, keyword_hit=[]){
      if(!work_experiences){
        return []
      }
      let workList = []
      work_experiences = JSON.parse(JSON.stringify(work_experiences));
      work_experiences.forEach(item=>{
        if(item.company_name || item.title){
          workList.push(item)
        }
      })
      return workList;
    },

    // 发送邀约
    async resumeApply(state, item, index){

      //如果投递字段为true 将hr状态调整为passed  状态state调整为true
      if(item.delivery_status){
        item.hr_permission_state = 'passed'
        state = true
      }

      // 用户在线简历状态是否隐藏 && 未邀约
      if(item.resume.cv_invisibile && !item.hr_permission_state){
        this.setNotfindResumeState(true);
        return false
      }

      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });

      //引导用户完善信息弹层
      if(!this.userInfoState){
        let user = get_tUser();
        if(user.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true)
          return false;
        }
      }
      // 检查是否已经邀约过
      if(state){
        let { cv_account_token } = item.resume;
        if(!cv_account_token){
          this.$message({
            message: '对方身份状态异常，无法创建聊天',
            type: 'success'
          });
          return
        }
        let data = {
          b_token: this.hr_account_token,
          c_token: cv_account_token,
          identity: item.delivery_status ? 'c' : 'b'
        }
        actions.im.post_relationships(data).then(async res=>{
          if(res.code === 1000){
            // 恢复隐藏好友状态
            try {
              await actions.im.putRelationshipsHide({
                b_token: this.hr_account_token, //用户token,
                c_token: cv_account_token, //被曝光的关系id
                b_hide: false, //是否隐藏联系人
              })
            } catch (error) { }
            setTimeout(() => {
              this.updateSmallChatOpenId(cv_account_token)
              // window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
              // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
            }, 300);
          }
        })
        return
      }
      // if (state === 'applied') {
      //   this.$message({
      //     message: '人才已收到邀约！继续联系更多人才获得回复率更高哦~',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      // if(state === 'passed'){
      //   this.$message({
      //     message: '已通过',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      if(item){
        this.updateResumeDetail(item)
      }
      if(!this.showResumeApplyState){
        //更新职位列表
        try {
          await this.getMyPosition()
        } catch (error) {}
        if(!this.myPosition.list.length){
          //提示
          this.toggleUserinfoTips(true)
          //更新信息弹层 提示文案类型
          this.toggleTipsType(2)
          return false;
        }

        // 检查是否绑定手机号
        if(!this.bindData.phone_is_bound){
          this.showBindPhone = true
          return
        }

        this.updateListOptions({
          ...this.listOptions,
          resumeIndex: index
        })
        //切换展示简历邀约样式
        this.updateBlockStateFun({type: 'showResumeApplyState', value: true})

        return false;
      }


    },
    // 邀约不合适（新接口）
    inviteUnsuited(item, index) {
      // console.log(item,"===============>item")
      // console.log(index,"===============>index")
      let data = {
        unsuited_reason: null,
        job_id: item.job_id ,
        user_id: item.resume.user_id,
        resume_id: item.resume.id
      }
      actions.job_deliveries.put_job_invite_status(data).then(res => {
        if(res.code===1000){
          this.$emit('checkListDeliveries', index)
          //更改未读红点数量
          this.updateMessageCount({type:'unsuited_job_deliveries_count',count: this.messageCount.unsuited_job_deliveries_count - 1})
          this.updateMessageCount({type: 'application_passed_count', count: this.messageCount.application_passed_count + 1})
          let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))
          // 直接请求的没有简历index
          if (index) {
            getStoreResumeList.list[index].unsuited = false;
          } else {
            this.updateShowResumeDetailState(false)
          }
          this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});
          //更改不合适状态
          if(this.resumeDetailToken){
            this.resumeDetail.unsuited = false;
            this.updateResumeDetail(this.resumeDetail)
          }
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },

    //取消不合适/不合适
    unsuitable(state, item, index){
      // console.log(item,"==========>item")
      // return;

      //更改未读状态
      if(state){
        if(this.resumeOperationState){
          return
        }
        // 简历是邀约的走邀约不合适接口
        if (!item.delivery_status) {
          this.inviteUnsuited(item, index)
          return;
        }
        this.resumeOperationState = true;
        let { job_id, resume } = item;
        let data = {
          type:'suited',
          job_id,
          user_id: resume.user_id,
        }
        // 直接走接口更改
        actions.job_deliveries.put_job_deliveries_status(data).then(res=>{
          this.resumeOperationState = false;

          if(res.code===1000){

            let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))
            getStoreResumeList.list[index].unsuited = false;
            this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});

            if(this.resumeDetailToken){
              this.resumeDetail.unsuited = false;
              this.updateResumeDetail(this.resumeDetail)
            }
            this.$emit('checkListDeliveries', index)
            //更改未读红点数量
            this.updateMessageCount({type:'unsuited_job_deliveries_count',count: this.messageCount.unsuited_job_deliveries_count - 1})
            // console.log(this.messageCount.unviewed_job_deliveries_count,"============》nnnn")
            this.updateMessageCount({type:'unviewed_job_deliveries_count',count: this.messageCount.unviewed_job_deliveries_count + 1})
            this.updateCvCount(this.messageCount.unviewed_job_deliveries_count)


          }else{
            this.$message({
            message: res.message,
            type: 'error'
          });
          }
        })

      }else{
        this.updateBlockStateFun({
          type:'unsuitableData',
          value: {
            showState: true, //是否展示不合适弹窗
            index: index, //不合适index
            deliveryState: item.delivery_status
          }
        })

      }
    },
    //【新投递】可以聊/跳转到聊天页面
    async deliveryToChatPage(item, index){
      let { cv_account_token } = item.resume;
      if(!cv_account_token){
        this.$message({
          message: '对方身份状态异常，无法创建聊天',
          type: 'success'
        });
        return
      }
      if(item.im_status){
        // 恢复隐藏好友状态
        try {
          await actions.im.putRelationshipsHide({
            b_token: this.hr_account_token, //用户token,
            c_token: cv_account_token, //被曝光的关系id
            b_hide: false, //是否隐藏联系人
          })
        } catch (error) { }
        setTimeout(() => {
          this.updateSmallChatOpenId(cv_account_token)
          // window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
          // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
        }, 300);
      }else{
        item.im_status = true;
        let { user_id } = item.resume;

        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))
        getStoreResumeList.list[index].im_status = true;
        getStoreResumeList.list[index].viewed = true;
        this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});

        let data = {
          type: 'communication',
          user_id: user_id,
          job_id: item.job_id
        }
        actions.job_deliveries.put_job_deliveries_status(data).then(res=>{
          let data = {
            b_token: this.hr_account_token,
            c_token: cv_account_token,
            identity: 'c',
            job_token: item.job_token
          }
          actions.im.post_relationships(data).then(async res=>{
            if(res.code === 1000){
              await actions.im.put_relationships_confirm(res.data.relationship.id);

              //更改未读红点数量
              this.updateMessageCount({type:'unviewed_job_deliveries_count',count: this.messageCount.unviewed_job_deliveries_count-1})

              setTimeout(() => {
                this.updateSmallChatOpenId(cv_account_token)
                // window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
                // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
              }, 300);
              // //重新获取用户列表
              // setTimeout(() => {
              //   this.get_relationships();
              // }, 1000);
            }
          })
        })
      }
    },

    // 更改无简历弹窗提示
    setNotfindResumeState(state){
      this.notfindResumeState = state;
    },
    //获取用户绑定信息
    getUsersBind(){
      actions.auth.getUserBind(this.userJWT.t).then(res=>{
        if(res.code === 1000){
          this.bindData = res.data;
        }
      })
    },
    //手机号绑定成功回调
    bindPhoneSuccess(){
      //重新获取用户绑定信息
      this.getUsersBind();
      this.showBindPhone = false;
    },
    // 关闭绑定手机号
    closeBindPhone(){
      this.showBindPhone = false;
    },

    toTopJob () {
      const { href } = this.$router.resolve({
        name: 'talentJobList',
        query: {
          origin: 'delivery'
        }
      })

      window.open(href, '_blank')
    },

    filterInfoSections, //过滤模块
    filterCustomSections, //获取自定义模块数据
    getAge, //获取年龄
    applied_at, //时间
    getDegreeName, //获取专业名称
    schoolTag, //学校卡片
    getWorkTimeLength, //计算工作时间

    async getPhone({item, index}){
      //检查职位是否已发布
      if(item.job_status === 'draft'){
        this.messgaeBoxInfo.desc = '发布'+item.job_post+'后，即可查看联系方式'
        this.showMessageBox = true
        return false
      }
      if(!(item.getPhoneState  || ( item.hr_permission_state==='rejected' || item.hr_permission_state==='passed'))){
        let res = await actions.job_deliveries.get_phone_times({});
        if(res.code === 1000){
          // this.updatePhoneNumber(res.data.check_contact_count )
          this.updatePhoneNumber(res.data.count)
        }else{
          this.updatePhoneNumber(0)
        }
        if(this.getPhoneNumber < 1){
          let params = {
            plan: 'view_phone_30',
          }
          let res = await actions.recruit_infos.create_order(params)
          if(res.code === 1000){
            this.updatePhoneNumberToken(res.data.order_token)
            this.updatePhoneNumberStateFun(true)
          }
        }else{
          this.toggleUserinfoTips(true);
          //更新信息弹层 提示文案类型
          this.toggleTipsType(3)
          // 更新搜索主页参数
          this.updateSearchIndexObj({
            index,
            itemIndex: index,
          });
          this.updateResumeDetailToken(item.resume.token)
          //更新页面数据
          this.updateListOptions({
            ...this.listOptions,
            resumeIndex: index
          })
        }
      }
    },
    // closeBuyPhone(){
    //   this.updatePhoneNumberToken('')
    //   this.updatePhoneNumberStateFun(false)
    // },
    // paidSuccFunc(){
    //   this.updatePhoneNumberToken('')
    //   this.updatePhoneNumberStateFun(false)
    // },
  },
}
</script>

<style lang="scss" scoped>

@import '@/assets/css/components/resumeList.scss';
/deep/ .beforeText > span:before{
  color: #CFCFCF;
  bottom: 1px;
}
.ellipsis{
  max-width: 708px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.remark{
  font-size: 12px;
  font-weight: 400;
  color: #9C9C9C;
  line-height: 16px;

  flex: 1;
}
.w200{
  width: 200px !important;
}
.pb{
  position: absolute;
}
.content{
  overflow: inherit;
  width: 100%;
  // padding-left: 78px;
}
/deep/.user-info{
  justify-content: normal !important;
  margin-top: 4px;
  padding-left: 70px;
  .userName{
    margin-right: 13px;
  }
}
//无数据
.talent_notfound{
  height: 580px;
  img{
    display: block;
    width: 112px;
    height: 112px;
    margin: 0 auto;
    padding-top: 140px;
  }
  p{
    line-height: 22px;
    margin:16px 42px 44px;
  }
  .button{
    width:104px;
    height:32px;
    line-height:32px;
    border-radius:2px;
    border:1px solid #4183FF;
    margin: 0 auto;
  }
}
  // .delivery{
  //   display: flex;
  //   align-items: flex-end;
  // }
  .disabled-state{
    border-radius:20px;
    border:1px solid rgba(236,236,236,1)!important;
    font-weight:400;
    color:rgba(188,188,188,1);
  }
  .colors{
    color:#D98614;
    font-size: 14px;
    padding: 5px 12px;
    background: linear-gradient(360deg, #FFE7C7 0%, #FFF8EF 100%);
    border-radius: 16px 2px 16px 2px;
  }
  .delivery-card-top {
    padding-left: 64px;
    position: relative;
    .choose-delivery {
      position: absolute;
      top: 35px;
      left: 32px;
      .iconfont {
        font-size: 18px;
        color: #CFCFCF;
      }
      .iconxuanzhong {
        color: #4183FF;
      }
    }
  }
</style>
